$ = require 'jquery'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/power_ups_voting_prefs'

module.exports = class VotingSettingsView extends View
  viewTitleKey: 'voting settings'

  initialize: ->
    @listenTo @model,
      'change:prefs': @render

  events:
    'click .js-voting-select:not(.disabled)': 'selectPerm'

  render: ->
    @$el.html(template({
      canChange: @model.editable()
      canSetObservers: @model.getOrganization()?.isFeatureEnabled('observers')
      canSetOrganization: @model.hasOrganization()
      canSetPublic: @model.isPublic()
      votingMode: @model.getPref('voting')
    }))

    @

  selectPerm: (e) ->
    Util.stop(e)
    $target = $(e.target).closest('.js-voting-select')

    setting = $target.attr('name')
    @model.setPref('voting', setting)



// WEBPACK FOOTER //
// ./app/scripts/views/power-ups/voting-settings-view.coffee